import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { Helmet } from "react-helmet";
import { FaPhone, FaEnvelope, FaMapMarkerAlt } from "react-icons/fa";

const ContactUs = () => {
  return (
    <React.Fragment>
      <Header />

      <div className="contact-page">
        <Helmet>
          <title>Contact Us - Topup Connect</title>
          <meta
            name="description"
            content="Get in touch with Topup Connect for mobile recharge, bill payments, and other services"
          />
        </Helmet>

        <section className="contact-hero">
          <div className="container">
            <h1>Contact Us</h1>
            <p>
              We'd love to hear from you! Reach out for any questions or
              support.
            </p>
          </div>
        </section>

        <div className="container contact-container">
          <div className="contact-info">
            <div className="contact-card">
              <div className="contact-item">
                <div className="contact-icon">
                  <FaPhone />
                </div>
                <div className="contact-text">
                  <h3>Phone</h3>
                  <p>+91 7890067005</p>
                  <p>Everyday, 9:00 AM - 9.00 PM</p>
                </div>
              </div>
            </div>

            <div className="contact-card">
              <div className="contact-item">
                <div className="contact-icon">
                  <FaEnvelope />
                </div>
                <div className="contact-text">
                  <h3>Email</h3>
                  <p>support@topupconnect.in</p>
                  <p>We typically respond within 24 hours</p>
                </div>
              </div>
            </div>

            <div className="contact-card">
              <div className="contact-item">
                <div className="contact-icon">
                  <FaMapMarkerAlt />
                </div>
                <div className="contact-text">
                  <h3>Address</h3>
                  <p>TOPUP CONNECT, Barasat - 1, Kathuria, Malikapur</p>
                  <p>Duttapukur, Barasat</p>
                  <p>North 24 Parganas, West Bengal - 700126</p>
                </div>
              </div>
            </div>
          </div>

          <div className="contact-form-container">
            <h2>Send us a message</h2>
            <form className="contact-form">
              <div className="form-group">
                <label htmlFor="name">Your Name</label>
                <input
                  type="text"
                  id="name"
                  placeholder="Enter your name"
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="email">Email Address</label>
                <input
                  type="email"
                  id="email"
                  placeholder="Enter your email"
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="phone">Phone Number</label>
                <input
                  type="tel"
                  id="phone"
                  placeholder="Enter your phone number"
                />
              </div>

              <div className="form-group">
                <label htmlFor="subject">Subject</label>
                <input
                  type="text"
                  id="subject"
                  placeholder="What's this about?"
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="message">Your Message</label>
                <textarea
                  id="message"
                  rows="5"
                  placeholder="How can we help you?"
                  required
                ></textarea>
              </div>

              <button type="submit" className="submit-btn">
                Send Message
              </button>
            </form>
          </div>
        </div>
      </div>

      <Footer />
    </React.Fragment>
  );
};

export default ContactUs;
